import { call, put, delay } from 'redux-saga/effects';
// COMMON
import { notification } from 'elements';
import * as actionTypes from '@/redux/new_store_structure/actions/actionsTypes';
import * as actions from '@/redux/new_store_structure/actions';
import { wsClient } from '@/index';

export function* getNotificationsListSaga(action) {
	/**
	 * @param clientId
	 */
	yield put({
		type: actionTypes.NOTIFICATIONS_START,
	});
	const { params } = action.payload;
	const requestPayload = {
		messageType: 'core.alert.list-alerts',
		payload: {
			...params,
		},
	};

	try {
		const { payload } = yield wsClient.request(requestPayload);
		yield put({
			type: actionTypes.NOTIFICATIONS_LIST_SUCCESS,
			payload,
		});
	} catch (error) {
		console.log('ERR', error);
		yield put({
			type: actionTypes.NOTIFICATIONS_FAILED,
			payload: { error },
		});
		yield call(notification.error, {
			message: 'Error',
			description: error.message,
			placement: 'bottomLeft',
		});
	}
}
export function* getNotificationsDetailsSaga(action) {
	/**
	 * @param clientId
	 */
	yield put({
		type: actionTypes.NOTIFICATIONS_START,
	});
	const { params } = action.payload;
	const requestPayload = {
		messageType: 'core.alert.get-alert',
		payload: {
			...params,
		},
	};

	try {
		const { payload } = yield wsClient.request(requestPayload);
		//TODO remove next err handlers when change architecture ...
		if (payload === null) {
			throw new Error('Notification does not exist');
		}
		if (payload.hasOwnProperty('message')) {
			throw new Error(payload.message);
		}
		yield put({
			type: actionTypes.NOTIFICATIONS_DETAILS_SUCCESS,
			payload,
		});
	} catch (error) {
		console.log('ERR', error);
		yield call(notification.error, {
			message: 'Error',
			description: error.message,
			placement: 'bottomLeft',
		});
		yield put({
			type: actionTypes.NOTIFICATIONS_FAILED,
			payload: error.message,
		});
	}
}

export function* delNotificationSaga(action) {
	/**
	 * @param clientId
	 * @param alertId
	 */
	const { params } = action.payload;
	const requestPayload = {
		messageType: 'core.alert.delete-alert',
		payload: {
			...params,
		},
	};

	try {
		const { res } = yield wsClient.request(requestPayload);
		yield put({
			type: actionTypes.NOTIFICATIONS_DELETE_SUCCESS,
			payload: { id: params.alertId },
		});
		yield call(notification.success, {
			message: 'Success',
			description: 'Notification successfully deleted',
			placement: 'bottomLeft',
		});
	} catch (error) {
		console.log('ERR', error);
		yield put({
			type: actionTypes.NOTIFICATIONS_FAILED,
			payload: { error },
		});
		yield call(notification.error, {
			message: 'Error',
			description: error.message,
			placement: 'bottomLeft',
		});
	}
}

export function* addEditNotificationSaga(action) {
	/**
	 * @param clientId
	 * @param alertId
	 */
	const { params, effect } = action.payload;
	const requestPayload = {
		messageType: `core.alert.${effect}-alert`,
		payload: {
			...params,
		},
	};

	try {
		const { res } = yield wsClient.request(requestPayload);
		yield put({
			type: actionTypes.NOTIFICATIONS_ADD_EDIT_SUCCESS,
			payload: { ...params },
		});
		yield call(notification.success, {
			message: 'Success',
			description: `Notification successfully ${effect}ed`,
			placement: 'bottomLeft',
		});
		yield call(actions.getNotificationsList, { clientId: params.clientId });
	} catch (error) {
		console.log('ERR', error);
		yield put({
			type: actionTypes.NOTIFICATIONS_FAILED,
			payload: { error },
		});
		yield call(notification.error, {
			message: 'Error',
			description: error.message,
			placement: 'bottomLeft',
		});
	}
}



// WEBPACK FOOTER //
// ./src/redux/new_store_structure/sagas/notifications.js